<template>
  <main id="top-layouts">
    <router-view />
  </main>
</template>

<script>
export default {
  name: "BaseTop",
  created() {
    this.$store.dispatch("loading/setLoading", false)
  }
}
</script>

<style scoped>
@media screen and (min-width: 993px) {
  body {
    overflow-y: hidden;
  }
}
</style>
